export default "__VITE_ASSET__EBoxTK9B__"